import { DiscordSDK } from '@discord/embedded-app-sdk';

let discordSdk = null;
let currentChannelId = 'default-room';

// Extrai o ID da sala/instância diretamente da URL fornecida pelo iFrame do Discord
function extractRoomFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const channelId = params.get('channel_id');
  const instanceId = params.get('instance_id');
  const guildId = params.get('guild_id');

  if (channelId) return channelId;
  if (instanceId) return instanceId;
  if (guildId) return guildId;
  return null;
}

// Verifica se a aplicação está rodando dentro do iFrame do cliente do Discord
export function isRunningInDiscord() {
  return window.self !== window.top || window.location.search.includes('frame_id') || window.location.search.includes('instance_id');
}

export function getChannelId() {
  const urlRoom = extractRoomFromUrl();
  if (urlRoom) return urlRoom;
  return currentChannelId;
}

// Configura o SDK do Discord e realiza a autenticação OAuth2
export async function setupDiscordSdk() {
  console.log('[Discord SDK] Inicializando verificação de ambiente...');

  // Determinar ID de sala infalível via URL
  const urlRoom = extractRoomFromUrl();
  if (urlRoom) {
    currentChannelId = urlRoom;
    console.log('[Discord SDK] Sala identificada via URL do iFrame:', currentChannelId);
  }

  if (!isRunningInDiscord()) {
    console.warn('[Discord SDK] Site acessado fora do Discord. Bloqueando acesso.');
    return { isDiscord: false, user: null, channelId: currentChannelId };
  }

  try {
    // 1. Obter o Client ID dinamicamente do backend Node.js
    const configRes = await fetch('/api/config');
    const { clientId } = await configRes.json();

    if (!clientId) {
      console.error('[Discord SDK] DISCORD_CLIENT_ID não encontrado no servidor.');
      return { isDiscord: true, user: { id: 'error-user', username: 'Erro de Configuração' }, channelId: currentChannelId };
    }

    // 2. Instanciar o SDK oficial do Discord
    discordSdk = new DiscordSDK(clientId);
    await discordSdk.ready();

    if (discordSdk.channelId) {
      currentChannelId = discordSdk.channelId;
    } else if (discordSdk.instanceId) {
      currentChannelId = discordSdk.instanceId;
    }
    const guildId = discordSdk.guildId || extractRoomFromUrl();
    console.log('[Discord SDK] SDK Pronto! Canal:', currentChannelId, 'Guild:', guildId);

    // 3. Autenticação OAuth2 do Usuário via SDK do Discord com escopo de membro do servidor
    const { code } = await discordSdk.commands.authorize({
      client_id: clientId,
      response_type: 'code',
      state: '',
      prompt: 'none',
      scope: ['identify', 'guilds.members.read'],
    });

    // 4. Trocar o código pelo access_token no nosso servidor backend e obter os cargos
    const tokenRes = await fetch('/api/token', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ code, guildId }),
    });

    const { access_token, roles } = await tokenRes.json();

    // 5. Autenticar o cliente do Discord com o token de acesso obtido
    const auth = await discordSdk.commands.authenticate({
      access_token,
    });

    if (!auth || !auth.user) {
      throw new Error('Falha ao autenticar usuário com o Discord SDK');
    }

    console.log('[Discord SDK] Usuário autenticado com sucesso:', auth.user.username, 'Cargos:', roles);

    return {
      isDiscord: true,
      channelId: currentChannelId,
      guildId,
      user: {
        id: auth.user.id,
        username: auth.user.username,
        discriminator: auth.user.discriminator,
        avatar: auth.user.avatar
          ? `https://cdn.discordapp.com/avatars/${auth.user.id}/${auth.user.avatar}.png`
          : 'https://cdn.discordapp.com/embed/avatars/0.png',
        roles: roles || [],
        guildId,
      },
    };

  } catch (error) {
    console.error('[Discord SDK Error] Falha durante o processo de setup:', error);
    return {
      isDiscord: true,
      channelId: currentChannelId,
      user: {
        id: 'auth-error-' + Math.floor(Math.random() * 1000),
        username: 'Espectador',
        avatar: 'https://cdn.discordapp.com/embed/avatars/0.png',
      },
    };
  }
}

// Abre o link de apresentação externo com token temporário de uso único
export async function openPresenterLink(channelId, user) {
  const targetChannelId = channelId || currentChannelId || extractRoomFromUrl() || 'default-room';

  try {
    const res = await fetch('/api/presenter/generate-token', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ channelId: targetChannelId, user }),
    });

    const data = await res.json();

    if (!res.ok || !data.success) {
      alert('Erro ao gerar link de apresentação: ' + (data.error || 'Erro interno'));
      return;
    }

    console.log(`[Discord SDK] Abrindo link nativo para a sala ${targetChannelId}:`, data.url);

    if (discordSdk && discordSdk.commands && discordSdk.commands.openExternalLink) {
      await discordSdk.commands.openExternalLink({ url: data.url });
    } else {
      window.open(data.url, '_blank');
    }
  } catch (err) {
    console.error('[Open Presenter Link Error]', err);
    alert('Não foi possível gerar o link de apresentação.');
  }
}
